import { UpdateSmartList } from '@griply/types';

import { FirestoreInstance } from '../types/firestore';
import { FirestoreCollections } from '../types/firestore-collections';

export type UpdateSmartListOptions<
  TDocRef = unknown,
  TFieldValue = unknown,
  TDb = FirestoreInstance,
> = {
  smartList: UpdateSmartList;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
  updateDoc: (
    ref: NoInfer<TDocRef>,
    data: Record<string, unknown>,
  ) => Promise<void>;
  db: TDb;
  serverTimestamp: () => TFieldValue;
};

export const updateSmartList = async <
  TDocRef,
  TFieldValue,
  TDb = FirestoreInstance,
>(
  options: UpdateSmartListOptions<TDocRef, TFieldValue, TDb>,
): Promise<void> => {
  const { smartList, doc, updateDoc, db, serverTimestamp } = options;

  const ref = doc(db, FirestoreCollections.SmartLists, smartList.id);

  await updateDoc(ref, {
    ...(smartList as unknown as Record<string, unknown>),
    updatedAt: serverTimestamp(),
  });
};
